import React, { useState } from 'react';
import { Switch } from 'antd';
import ControlPanel from './ControlPanel';
import { toggleSpeed } from '../../scripts/cy-constant';

const GraphControlPanel = ({ currentNode }) => {
  const [showPanel, setShowPanel] = useState(true);

  const toggleSibling = (chkbox, toggleClass) => {
    // debug-console.log('toggleSibling:', chkbox);

    if (!$(chkbox).hasClass('switch')) {
      // // debug-console.log('toggleSibling:', $(chkbox).hasClass('switch'));
      chkbox = $(chkbox).parent('.switch');
    }
    const target = $(chkbox).siblings();
    // debug-console.log('toggleSibling: target=', target);
    if (!toggleClass) {
      target.slideToggle(toggleSpeed);
    } else {
      target.toggleClass(toggleClass);
    }
    // // debug-console.log('toggleClass ',toggleClass);
  };

  return (
    <div id="cPanelWrapper" className="col-lg-4 col-xs-12">
      <div id="graphControlPanel" className="border-gray togglable">
        <Switch
          id="controlPanelSwitch"
          size="large"
          defaultChecked
          className="switch"
          onClick={(e) => {
            // debug-console.log('showPanel=' + showPanel);
            toggleSibling('#controlPanelSwitch', 'hide');
            setShowPanel(!showPanel);
          }}
        />
        <ControlPanel currentNode={currentNode} showPanel={showPanel} />
      </div>
    </div>
  );
};

export default GraphControlPanel;
